// extracted by mini-css-extract-plugin
export default {"infocard":"Infocard_infocard__J7xLJ","left":"Infocard_left__Uz0Vd","container":"Infocard_container__Vx9dW","chevronimg":"Infocard_chevronimg__L2+Kf"};